export default __webpack_public_path__ + "static/media/beach.f1deb69a.jpeg";